import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import SidebarMenuItem from 'src/components/ui/atoms/SidebarMenuItem/SidebarMenuItem'
import SidebarMenuProductIcon from 'src/components/ui/molecules/SidebarMenuProductIcon/SidebarMenuProductIcon'
import { cn } from 'src/lib/cn'
import useSidebarStore from 'src/stores/useSidebarStore'
import { CommonPage } from 'src/utils/product'

const LINK = `/${CommonPage.SelfServiceMapping}`

const SidebarFooterMapping: FC = () => {
  const isSidebarOpen = useSidebarStore(s => s.isOpen || s.searchInputFocusedId !== null)
  const { pathname } = useLocation()
  const isActive = pathname === LINK

  return (
    <SidebarMenuItem
      to={LINK}
      aria-label="Mapping"
      active={isActive}
      icon={<SidebarMenuProductIcon code="self_service" />}
      label={isSidebarOpen ? 'Mapping' : ''}
      className={cn('px-3', isSidebarOpen && 'px-4')}
      withLaunchingLink={true}
      data-testid="sidebar-footer-mapping"
    />
  )
}

export default SidebarFooterMapping
